import { useEffect, useState } from "react";
import {
  useAreaData,
  usePoliceStationData,
  useShopData,
  useShopDetailsExcel,
  useShopDetailsPagination,
  useShopOwnRentorSubtenantCount,
  useTrackingDetailsExcel,
  useTrackingDetailsPagination,
  useTypeMasterData,
  useZoneData,
} from "../../API_Master/GetAPI";
import Cookies from "js-cookie";
import Select from "react-select";
import Flatpickr from "react-flatpickr";
import PageEntries from "../../Components/PageEntries";
import PaginationButtons from "../../Components/PaginationButtons";
import { exportToExcel, notifyError, validateStartAndEndDate } from "../../HelperMethods";
import { toast } from "react-toastify";
import { NIGHT_EYE_IMG_URL } from "../../Process";
import ShopReportModal from "../../Components/ShopReportModel";
import PageCountSelect from "../../Components/PageCountSelect";
import NoDataFound from "../../Components/NoDataFound";
import ShopDetailModal from "../../Components/ShopProfileView";
import { useShopIsActiveStatus } from "../../API_Master/MutateAPI";
import { mainRouteInitial } from "../../Data/Constant";
import { useLocation, useNavigate } from "react-router-dom";
import DirectionMap from "./DirectionMap";
import "./index.css";
import { ShopQR } from "./shopQr";

const ShimmerRow = () => (
  <tr className="animate-pulse">
    <td className="py-5 px-3 pl-6">
      <div className="h-5  bg-slate-200 dark:bg-slate-700 rounded"></div>
    </td>
    <td className="py-5 px-3">
      <div className="h-5  bg-slate-200 dark:bg-slate-700 rounded"></div>
    </td>
    <td className="py-5 px-3">
      <div className="h-5  bg-slate-200 dark:bg-slate-700 rounded"></div>
    </td>
    <td className="py-5 px-3">
      <div className="h-5  bg-slate-200 dark:bg-slate-700 rounded"></div>
    </td>
    <td className="py-5 px-3">
      <div className="h-5  bg-slate-200 dark:bg-slate-700 rounded"></div>
    </td>
    <td className="py-5 px-3">
      <div className="h-5  bg-slate-200 dark:bg-slate-700 rounded"></div>
    </td>
    <td className="py-5 px-3">
      <div className="h-5  bg-slate-200 dark:bg-slate-700 rounded"></div>
    </td>
    <td className="py-5 px-3">
      <div className="h-5  bg-slate-200 dark:bg-slate-700 rounded"></div>
    </td>
    <td className="py-5 px-3">
      <div className="h-5  bg-slate-200 dark:bg-slate-700 rounded"></div>
    </td>
    <td className="py-5 px-3">
      <div className="h-5  bg-slate-200 dark:bg-slate-700 rounded"></div>
    </td>
  </tr>
);
const DepartmentVendorLIst = () => {
  const navigate = useNavigate();
  const { data: typeMasterData = [] } = useTypeMasterData("StallType");

  const [shopProfileDetailView, setShopProfileDetailView] = useState({});
  const [openShopDetails, setOpenShopDetails] = useState(false);
  const [isFiltersOpen, setIsFiltersOpen] = useState(false); // ← starts collapsed
  const [currentPage, setCurrentPage] = useState(0); // index: 0 = page 1
  const [isReportModalOpen, setIsReportModalOpen] = useState(false);
  const [selectedShop, setSelectedShop] = useState(null);
  const [openTableDetails, setOpenTableDetails] = useState({});
  const { mutate: toggleStatus, isPending: updatingStatus } = useShopIsActiveStatus();
  const location = useLocation();

  const receivedFilterData = location?.state?.filterData;
  console.log("sdfjskdsdfsdfsdfjsksafd", receivedFilterData);
  const [selectedImage, setSelectedImage] = useState(null);
  const [filterData, setFilterData] = useState({
    cityID: Cookies.get("NIGHT_EYE_CITY_ID") || "",
    zoneID: receivedFilterData?.["zoneID"] || Cookies.get("NIGHT_EYE_ZONE_ID") || "",
    policeStationID: receivedFilterData?.["policeStationID"] || Cookies.get("NIGHT_EYE_POLICE_STATION_ID") || "",
    areaID: receivedFilterData?.["areaID"] || Cookies.get("NIGHT_EYE_AREA_ID") || "",
    shopDetailID: "",
    shopOwnerMobileNo: "",
    shopOwnerName: "",
    shopName: "",
    shopType: "",
    isCCTVAvailable: "",
    isStreetLightAvailable: "",
    isAgreementAvailable: "",
    isShopOwnorOnRentOrOnSubTenant: "",
    isRentExpired: "",
    createdByUserID: "",
    // "startDate": subDays(new Date(), 7),
    // "startDate": new Date(),
    // "endDate": new Date(),
    startDate: receivedFilterData?.["startDate"] || "",
    endDate: receivedFilterData?.["startDate"] || "",
  });

  const [modelFilter, setModelFilter] = useState({
    cityID: Cookies.get("NIGHT_EYE_CITY_ID") || "",
    zoneID: receivedFilterData?.["zoneID"] || Cookies.get("NIGHT_EYE_ZONE_ID") || "",
    policeStationID: receivedFilterData?.["policeStationID"] || Cookies.get("NIGHT_EYE_POLICE_STATION_ID") || "",
    areaID: receivedFilterData?.["areaID"] || Cookies.get("NIGHT_EYE_AREA_ID") || "",
    shopDetailID: "",
    shopOwnerMobileNo: "",
    shopOwnerName: "",
    shopName: "",
    shopType: "",
    isCCTVAvailable: "",
    isStreetLightAvailable: "",
    isAgreementAvailable: "",
    isShopOwnorOnRentOrOnSubTenant: "",
    isRentExpired: "",
    createdByUserID: "",
    // "startDate": subDays(new Date(), 7),
    // "startDate": new Date(),
    // "endDate": new Date(),
    startDate: receivedFilterData?.["startDate"] || "",
    endDate: receivedFilterData?.["startDate"] || "",
  });

  const [rowsPerPage, setRowsPerPage] = useState(10);
  const { data, fetchNextPage, hasNextPage, isFetching, isLoading, isError, refetch } = useShopDetailsPagination(rowsPerPage, filterData);

  const countFilterData = {
    cityID: Cookies.get("NIGHT_EYE_CITY_ID") || "",
    zoneID: receivedFilterData?.["zoneID"] || Cookies.get("NIGHT_EYE_ZONE_ID") || "",
    policeStationID: receivedFilterData?.["policeStationID"] || Cookies.get("NIGHT_EYE_POLICE_STATION_ID") || "",
    areaID: receivedFilterData?.["areaID"] || Cookies.get("NIGHT_EYE_AREA_ID") || "",
  };

  const { data: countData = [] } = useShopOwnRentorSubtenantCount(countFilterData);

  const { mutate: exportUser, isPending: isExporting } = useShopDetailsExcel();

  const pages = data?.pages || [];
  const totalCount = data?.pages[0]?.TotalCount || 0;
  const currentItems = data?.pages[currentPage]?.data || [];

  const start = currentPage * rowsPerPage + 1;
  const end = Math.min(start + currentItems.length - 1, totalCount);

  const stallTypeOptions = typeMasterData?.map((ele) => ({
    value: ele?.TypeMasterID,
    label: ele?.Type,
  }));
  useEffect(() => {
    const temptObj = {};
    currentItems?.map((ele) => {
      temptObj[ele.ShopDetailID] = ele.IsActive;
    });
    setOpenTableDetails(temptObj);
  }, [data]);

  const handleShowHideTableDetails = (shopDetailID, updatedStatus) => {
    try {
      const payload = {
        ShopDetailID: shopDetailID || "",
        IsActive: updatedStatus ? "true" : "false",
        UpdatedByUserID: Cookies.get("NIGHT_EYE_USER_ID"),
      };
      toggleStatus(payload, {
        onSuccess: (res) => {
          if (res?.status === true) {
            setOpenTableDetails((prev) => ({
              ...prev,
              [shopDetailID]: updatedStatus,
            }));
          } else {
            // setUserTokenUniqueID("")
            return notifyError(res?.message || "Oppss! Could'nt Update Status, Please Try Again Later");
          }
        },
        onError: (err) => {
          return notifyError("Oppss! Could'nt Update Status, Please Try Again Later");
        },
      });
    } catch (err) {}
  };

  const handleFilterSearch = () => {
    console.log(modelFilter, "modelFiltermodelFilter");
    if (!validateStartAndEndDate(modelFilter?.startDate, modelFilter?.endDate)) {
      return;
    }
    setFilterData(modelFilter);
  };
  const goToPage = async (index) => {
    if (pages[index]) {
      setCurrentPage(index);
    } else if (hasNextPage) {
      await fetchNextPage(); // loads next page
      setCurrentPage(index);
    }
  };

  const openModal = (imageUrl) => {
    setSelectedImage(imageUrl);
  };

  const closeModal = () => {
    setSelectedImage(null);
  };
  const handleRowsChange = async (e) => {
    const limit = parseInt(e.target.value);
    setRowsPerPage(limit);
    setCurrentPage(0);
    await refetch(); // reload from start
  };
  const handleExport = (exportType) => {
    toast.dismiss();

    exportUser(filterData, {
      onSuccess: (tireMaseter) => {
        if (!tireMaseter?.length) {
          return notifyError("No Data Found");
        }

        const exportData = tireMaseter.map((shop, index) => {
          const firstOwner = shop.ShopOwnerDetail?.[0] || {};
          const firstUser = shop.ShopUserDetail?.[0] || {};

          // ── Helpers ────────────────────────────────────────────────────────
          // Format: "Name (Mobile), Name (Mobile), ..."
          const helpersSummary =
            (shop.ShopHelperDetail || [])
              .map((h) => {
                const name = h.HelperName?.trim() || "Unknown";
                const mobile = h.HelperMobileNo?.trim() || "";
                const role = h.HelperRoleName?.trim() || "";
                return mobile ? `${name}-${role} (${mobile})` : name;
              })
              .filter(Boolean)
              .join(", ") || "-";

          // ── Amenities ──────────────────────────────────────────────────────
          // Two separate columns — only show names that match the status
          const amenitiesAvailable =
            (shop.ShopAmenitiesDetail || [])
              .filter((a) => a.IsAvailable === true || a.IsAvailable === "true")
              .map((a) => a.AmenitiesName?.trim() || "Unknown")
              .join(", ") || "-";

          const amenitiesNotAvailable =
            (shop.ShopAmenitiesDetail || [])
              .filter((a) => a.IsAvailable === false || a.IsAvailable === "false")
              .map((a) => a.AmenitiesName?.trim() || "Unknown")
              .join(", ") || "-";

          return {
            "Sr No": index + 1,
            // "Shop Unique ID": shop.ShopUniqueID || "-",
            "Shop Name": shop.ShopName || "-",

            // First Shop User
            "Shop User Name": firstUser.ShopUserName || "-",
            "Shop User Mobile": firstUser.ShopUserMobileNo || "-",
            "Shop User Aadhaar No": firstUser.AadhaarCardNo || "-",

            Type: shop.Type || "-",
            "Other Type": shop.OtherTypeMasterName || "-",
            "Mobile No 1": shop.ShopMobileNo1 || "-",
            "Mobile No 2": shop.ShopMobileNo2 || "-",
            "Mobile No 3": shop.ShopMobileNo3 || "-",
            // "Open Time": shop.ShopOpenTime || "-",
            // "Close Time": shop.ShopCloseTime || "-",
            "Working Time": `${shop.ShopOpenTime || ""} – ${shop.ShopCloseTime || ""}`.trim() || "-",
            Address: shop.Address || "-",
            Area: shop.AreaName || "-",
            "Other Area": shop.OtherArea || "-",
            City: shop.CityName || "-",
            Zone: shop.ZoneName || "-",
            "Police Station": shop.PoliceStation || "-",
            "Ownership Type": shop.IsShopOwnorOnRentOrOnSubTenant || "-",
            "Rent Expiry Date": shop.RentExpiryDate || "-",

            // "Open by Other Employee": shop.IsShopOpenByOtherEmployee ? "Yes" : "No",
            // "Verified Status": shop.ShopVerifiedStatus === "true" ? "Verified" : "Pending",
            // "Verified Type": shop.ShopVerifiedType || "-",
            // "Verified By User ID": shop.ShopVerifiedByUserID || "-",
            // "Verified DateTime": shop.ShopVerifiedByDateTime || "-",
            "Created Date": shop.CreatedDate || "-",
            // "Created By": shop.CreatedByUserName || "-",

            // First Owner
            "Owner Name": firstOwner.ShopUserName || firstOwner.OwnerName || "-",
            "Owner Mobile": firstOwner.OwnerMobileNo || "-",
            "Owner Address": firstOwner.OwnerAddress || "-",

            // Cleaner summaries
            Helpers: helpersSummary,
            "Amenities Available": amenitiesAvailable,
            "Amenities Not Available": amenitiesNotAvailable,
            // Agreement Files column removed as requested
          };
        });

        exportToExcel(exportData, "Vendor_Details");
      },

      onError: () => {
        notifyError("Export failed. Please try again.");
      },
    });
  };

  // const isCityLogin = Cookies.get("DP_NIGHT_EYE_USER_ROLE") === "cityuser";
  // const isZoneLogin = Cookies.get("DP_NIGHT_EYE_USER_ROLE") === "zoneuser";
  // const isPSLogin = Cookies.get("DP_NIGHT_EYE_USER_ROLE") === "policestationuser";
  const isCityLogin = true;
  const isZoneLogin = true;
  const isPSLogin = true;

  const { data: zoneData = [] } = useZoneData(modelFilter?.cityID, Cookies.get("NIGHT_EYE_ZONE_ID"));
  const { data: policeStationData = [] } = usePoliceStationData(modelFilter?.cityID, modelFilter?.zoneID, Cookies.get("NIGHT_EYE_POLICE_STATION_ID"));
  const { data: areaData = [] } = useAreaData(modelFilter?.cityID, modelFilter.zoneID, modelFilter?.policeStationID, Cookies.get("NIGHT_EYE_AREA_ID"));
  const { data: shopData = [] } = useShopData(modelFilter?.cityID, modelFilter.zoneID, modelFilter?.policeStationID, modelFilter?.areaID);

  const zoneOptions = zoneData?.map((ele) => ({
    value: ele?.ZoneID,
    label: ele?.ZoneName,
  }));
  const policeStationOptions = policeStationData?.map((ele) => ({
    value: ele?.PoliceStationID,
    label: ele?.PoliceStation,
  }));
  const areaOptions = areaData?.map((ele) => ({
    value: ele?.AreaID,
    label: ele?.AreaName,
  }));
  const shopOptions = shopData?.map((ele) => ({
    value: ele?.ShopDetailID,
    label: ele?.ShopName,
  }));
  useEffect(() => {
    if (isZoneLogin && zoneOptions.length == 1) {
      setFilterData((prev) => {
        return {
          ...prev,
          zoneID: zoneOptions?.[0].value || "",
        };
      });
    } else if (isPSLogin && policeStationOptions.length == 1) {
      setFilterData((prev) => {
        return {
          ...prev,
          policeStationID: policeStationOptions?.[0].value || "",
        };
      });
    }
  }, []);

  const selectStyles = {
    control: (provided, state) => ({
      ...provided,
      minHeight: "38px",
      backgroundColor: "rgb(248 250 252)",
      borderColor: state.isFocused ? "#3b82f6" : "rgb(226 232 240)",
      boxShadow: state.isFocused ? "0 0 0 3px rgba(59,130,246,0.15)" : "none",
      borderRadius: "0.5rem",
      "&:hover": { borderColor: "#94a3b8" },
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: "2px 12px",
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "#1e293b",
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "#94a3b8",
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: "0.5rem",
      boxShadow: "0 10px 15px -3px rgba(0,0,0,0.1)",
    }),
  };

  const handleSelectFilterData = (name, value) => {
    if (name == "zoneID") {
      setModelFilter((prev) => {
        return {
          ...prev,
          [name]: value,
          policeStationID: Cookies.get("NIGHT_EYE_POLICE_STATION_ID") || "",
          areaID: Cookies.get("NIGHT_EYE_AREA_ID") || "",
        };
      });
    } else if (name == "policeStationID") {
      setModelFilter((prev) => {
        return {
          ...prev,
          [name]: value,
          areaID: Cookies.get("NIGHT_EYE_AREA_ID") || "",
        };
      });
    } else {
      setModelFilter((prev) => {
        return {
          ...prev,
          [name]: value,
        };
      });
    }
  };
  const handleReset = () => {
    setFilterData({
      cityID: Cookies.get("NIGHT_EYE_CITY_ID") || "",
      zoneID: Cookies.get("NIGHT_EYE_ZONE_ID") || "",
      policeStationID: Cookies.get("NIGHT_EYE_POLICE_STATION_ID") || "",
      areaID: Cookies.get("NIGHT_EYE_AREA_ID") || "",
      shopDetailID: "",
      shopOwnerMobileNo: "",
      shopOwnerName: "",
      shopName: "",
      shopType: "",
      isCCTVAvailable: "",
      isStreetLightAvailable: "",
      isAgreementAvailable: "",
      isShopOwnorOnRentOrOnSubTenant: "",
      isRentExpired: "",
      createdByUserID: "",
      // "startDate": subDays(new Date(), 7),
      // "startDate": new Date(),
      // "endDate": new Date(),
      startDate: "",
      endDate: "",
    });
    setModelFilter({
      cityID: Cookies.get("NIGHT_EYE_CITY_ID") || "",
      zoneID: Cookies.get("NIGHT_EYE_ZONE_ID") || "",
      policeStationID: Cookies.get("NIGHT_EYE_POLICE_STATION_ID") || "",
      areaID: Cookies.get("NIGHT_EYE_AREA_ID") || "",
      shopDetailID: "",
      shopOwnerMobileNo: "",
      shopOwnerName: "",
      shopName: "",
      shopType: "",
      isCCTVAvailable: "",
      isStreetLightAvailable: "",
      isAgreementAvailable: "",
      isShopOwnorOnRentOrOnSubTenant: "",
      isRentExpired: "",
      createdByUserID: "",
      // "startDate": subDays(new Date(), 7),
      // "startDate": new Date(),
      // "endDate": new Date(),
      startDate: "",
      endDate: "",
    });
  };

  const handleVendorReport = (item) => {
    setIsReportModalOpen(true);
    setSelectedShop(item);
  };

  const onReportModelclose = () => {
    setIsReportModalOpen(false);
    setSelectedShop();
  };
  const handleViewShopDetails = (item) => {
    setShopProfileDetailView(item);
    setOpenShopDetails(true);
  };
  const handleCloseShopDetails = () => {
    setShopProfileDetailView();
    setOpenShopDetails(false);
  };
  const handleToggleStatus = (shopDetailID, newStatus, index) => {
    toast.dismiss();
    // Optional: optimistic UI update
    // You can update local state or invalidate queries

    // Real API call example:
    // toggleShopStatus(
    //   { shopDetailID: shop.ShopDetailID, isActive: newStatus },
    //   {
    //     onSuccess: () => {
    //       toast.success(`Shop ${newStatus ? "activated" : "deactivated"}`);
    //       refetch(); // or queryClient.invalidateQueries(...)
    //     },
    //     onError: () => toast.error("Failed to update status")
    //   }
    // );

    toast.info("Toggle clicked – implement API call here");
    // console.log("Toggling shop:", shop.ShopDetailID, "to", newStatus);
  };
  const handleAddMoreShop = (shop) => {
    Cookies.set("IsStep1Completed", false);
    Cookies.set("IsStep2Completed", false);
    Cookies.set("IsStep3Completed", false);
    Cookies.set("VenderMobileNo", shop?.ShopUserDetail?.[0]?.ShopUserMobileNo);
    Cookies.set("VENDER_NIGHT_EYE_USER_ID", shop?.ShopUserDetail?.[0]?.ShopOwnerUserID || "");
    Cookies.remove("NIGHT_EYE_SHOP_DETAIL_ID");
    navigate(`/${mainRouteInitial}/VendorRegistration`);
  };
  const handleEditShop = (shop) => {
    Cookies.set("VenderMobileNo", shop?.ShopUserDetail?.[0]?.ShopUserMobileNo);
    Cookies.set("VENDER_NIGHT_EYE_USER_ID", shop?.ShopUserDetail?.[0]?.ShopOwnerUserID || "");
    Cookies.set("NIGHT_EYE_SHOP_DETAIL_ID", shop?.ShopDetailID);
    const isAllDetailsCompleted = shop.IsStep1 && shop.IsStep2 && shop.IsStep3;
    Cookies.set("IsStep1Completed", isAllDetailsCompleted ? false : shop.IsStep1);
    Cookies.set("IsStep2Completed", isAllDetailsCompleted ? false : shop.IsStep2);
    Cookies.set("IsStep3Completed", isAllDetailsCompleted ? false : shop.IsStep3);
    navigate(`/${mainRouteInitial}/VendorRegistration`);
  };

  const [directionData, setDirectionData] = useState(null);
  const [openMapModel, setOpenMapModel] = useState(false);

  const directionOnMap = (data) => {
    setDirectionData(data);
    setOpenMapModel(true);
  };

  return (
    <main className="flex-1 overflow-y-auto p-3 md:px-8 scroll-smooth">
      <div className="mx-auto max-w-7xl flex flex-col gap-3">
        {/* Filters & Map Toolbar */}
        <div className="bg-white dark:bg-slate-800 rounded-xl shadow-sm border border-slate-200 dark:border-slate-700">
          {/* Header with title + toggle + optional reset icon */}
          <div className="px-4 sm:px-6 py-0 border-b border-slate-200 dark:border-slate-700 flex items-center justify-between">
            <div className="flex items-center gap-2.5">
              <span className="material-symbols-outlined text-blue-600 text-2xl">filter_list</span>
              <h3 className="text-base font-semibold text-slate-800 dark:text-slate-100">Filters</h3>
              <span className="text-[14px] text-slate-500 dark:text-slate-400 countcss">{totalCount}</span>
            </div>

            <div className="flex items-center gap-1.5 sm:gap-2">
              {/* Collapse / Expand Button */}
              <button
                onClick={() => setIsFiltersOpen((prev) => !prev)}
                title={isFiltersOpen ? "Collapse filters" : "Expand filters"}
                className="p-1.5 sm:p-2 rounded-lg hover:bg-slate-100 dark:hover:bg-slate-700 text-slate-500 hover:text-slate-700 dark:text-slate-400 dark:hover:text-slate-200 transition-colors"
              >
                <span className="material-symbols-outlined text-xl sm:text-2xl">{isFiltersOpen ? "expand_less" : "expand_more"}</span>
              </button>

              {/* Optional: small reset icon in header */}
              <button
                onClick={handleReset}
                title="Reset filters"
                className="p-1.5 sm:p-2 rounded-lg hover:bg-slate-100 dark:hover:bg-slate-700 text-slate-500 hover:text-slate-700 dark:text-slate-400 dark:hover:text-slate-200 transition-colors hidden sm:block"
              >
                <span className="material-symbols-outlined text-xl sm:text-2xl">restart_alt</span>
              </button>
            </div>
          </div>

          {/* Collapsible content */}
          {isFiltersOpen && (
            <div className="p-4 sm:p-6 transition-all duration-200 ease-in-out">
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-5 gap-4">
                {/* Zone */}
                {(isCityLogin || isZoneLogin) && (
                  <div className="flex flex-col gap-1.5">
                    <label className="text-xs font-medium text-slate-600 dark:text-slate-400">Zone</label>
                    <Select
                      options={[{ label: "Select All", value: Cookies.get("NIGHT_EYE_ZONE_ID") || "" }, ...zoneOptions]}
                      value={zoneOptions.find((opt) => opt.value === modelFilter?.zoneID) || null}
                      onChange={(opt) => handleSelectFilterData("zoneID", opt?.value || "")}
                      placeholder="Select Zone"
                      styles={selectStyles}
                      classNamePrefix="react-select"
                    />
                  </div>
                )}

                {/* Police Station */}
                {(isCityLogin || isZoneLogin || isPSLogin) && (
                  <div className="flex flex-col gap-1.5">
                    <label className="text-xs font-medium text-slate-600 dark:text-slate-400">Police Station</label>
                    <Select
                      options={[{ label: "Select All", value: Cookies.get("NIGHT_EYE_POLICE_STATION_ID") || "" }, ...policeStationOptions]}
                      value={policeStationOptions.find((opt) => opt.value === modelFilter?.policeStationID) || null}
                      onChange={(opt) => handleSelectFilterData("policeStationID", opt?.value || "")}
                      placeholder="Select Police Station"
                      styles={selectStyles}
                      classNamePrefix="react-select"
                    />
                  </div>
                )}

                {/* Area */}
                {(isCityLogin || isZoneLogin || isPSLogin) && (
                  <div className="flex flex-col gap-1.5">
                    <label className="text-xs font-medium text-slate-600 dark:text-slate-400">Area</label>
                    <Select
                      options={[{ label: "Select All", value: Cookies.get("NIGHT_EYE_AREA_ID") || "" }, ...areaOptions]}
                      value={areaOptions.find((opt) => opt.value === modelFilter?.areaID) || null}
                      onChange={(opt) => handleSelectFilterData("areaID", opt?.value || "")}
                      placeholder="Select Area"
                      styles={selectStyles}
                      classNamePrefix="react-select"
                    />
                  </div>
                )}

                {/* <div className="flex flex-col gap-1.5">
                                    <label className="text-xs font-medium text-slate-600 dark:text-slate-400">
                                        Shop Name
                                    </label>
                                    <input
                                        type="text"
                                        value={modelFilter?.shopName || ""}
                                        onChange={(e) => handleSelectFilterData("shopName", e.target.value)}
                                        placeholder="Search shop name..."
                                        className="w-full px-3 py-2 border border-slate-300 dark:border-slate-600 rounded-lg bg-slate-50 dark:bg-slate-700 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all"
                                    />
                                </div> */}

                {/* 2. Shop Owner Name */}
                <div className="flex flex-col gap-1.5">
                  <label className="text-xs font-medium text-slate-600 dark:text-slate-400">Owner Name</label>
                  <input
                    type="text"
                    value={modelFilter?.shopOwnerName || ""}
                    onChange={(e) => handleSelectFilterData("shopOwnerName", e.target.value)}
                    placeholder="Search owner name..."
                    className="w-full px-3 py-2 border border-slate-300 dark:border-slate-600 rounded-lg bg-slate-50 dark:bg-slate-700 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all"
                  />
                </div>

                {/* 3. Shop Owner Mobile No */}
                <div className="flex flex-col gap-1.5">
                  <label className="text-xs font-medium text-slate-600 dark:text-slate-400">Owner Mobile</label>
                  <input
                    type="text"
                    value={modelFilter?.shopOwnerMobileNo || ""}
                    onChange={(e) => {
                      // Optional: allow only numbers + limited length
                      const val = e.target.value.replace(/[^0-9]/g, "").slice(0, 10);
                      handleSelectFilterData("shopOwnerMobileNo", val);
                    }}
                    placeholder="10-digit mobile number"
                    className="w-full px-3 py-2 border border-slate-300 dark:border-slate-600 rounded-lg bg-slate-50 dark:bg-slate-700 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all"
                    maxLength={10}
                  />
                </div>

                {/* Shop */}
                <div className="flex flex-col gap-1.5">
                  <label className="text-xs font-medium text-slate-600 dark:text-slate-400">Shop</label>
                  <Select
                    options={[{ label: "Select All", value: "" }, ...shopOptions]}
                    value={shopOptions.find((opt) => opt.value === modelFilter?.shopDetailID) || null}
                    onChange={(opt) => handleSelectFilterData("shopDetailID", opt?.value || "")}
                    placeholder="Select Shop"
                    styles={selectStyles}
                    classNamePrefix="react-select"
                  />
                </div>
                <div className="flex flex-col gap-1.5">
                  <label className="text-xs font-medium text-slate-600 dark:text-slate-400">CCTV Available</label>
                  <Select
                    options={[
                      { value: "", label: "All" },
                      // { value: "1", label: "Yes" },
                      // { value: "0", label: "No" },
                      { value: "yes", label: "Yes" },
                      { value: "no", label: "No" },
                      { value: "notapplicable", label: "Not Applicable" },
                    ]}
                    value={
                      [
                        { value: "", label: "All" },
                        { value: "yes", label: "Yes" },
                        { value: "no", label: "No" },
                        { value: "notapplicable", label: "Not Applicable" },
                      ].find((opt) => opt.value === modelFilter.isCCTVAvailable) || null
                    }
                    onChange={(opt) => handleSelectFilterData("isCCTVAvailable", opt?.value || "")}
                    placeholder="All"
                    styles={selectStyles}
                    classNamePrefix="react-select"
                  />
                </div>

                <div className="flex flex-col gap-1.5">
                  <label className="text-xs font-medium text-slate-600 dark:text-slate-400">Rent Agreement</label>
                  <Select
                    options={[
                      { value: "", label: "All" },
                      // { value: "1", label: "Yes" },
                      // { value: "0", label: "No" },
                      { value: "yes", label: "Yes" },
                      { value: "no", label: "No" },
                      { value: "notapplicable", label: "Not Applicable" },
                    ]}
                    value={
                      [
                        { value: "", label: "All" },
                        // { value: "1", label: "Yes" },
                        // { value: "0", label: "No" },
                        { value: "yes", label: "Yes" },
                        { value: "no", label: "No" },
                        { value: "notapplicable", label: "Not Applicable" },
                      ].find((opt) => opt.value === modelFilter.isAgreementAvailable) || null
                    }
                    onChange={(opt) => handleSelectFilterData("isAgreementAvailable", opt?.value || "")}
                    placeholder="All"
                    styles={selectStyles}
                    classNamePrefix="react-select"
                  />
                </div>

                <div className="flex flex-col gap-1.5">
                  <label className="text-xs font-medium text-slate-600 dark:text-slate-400">Street Light</label>
                  <Select
                    options={[
                      { value: "", label: "All" },
                      // { value: "1", label: "Yes" },
                      // { value: "0", label: "No" },
                      { value: "yes", label: "Yes" },
                      { value: "no", label: "No" },
                      { value: "notapplicable", label: "Not Applicable" },
                    ]}
                    value={
                      [
                        { value: "", label: "All" },
                        // { value: "1", label: "Yes" },
                        // { value: "0", label: "No" },
                        { value: "yes", label: "Yes" },
                        { value: "no", label: "No" },
                        { value: "notapplicable", label: "Not Applicable" },
                      ].find((opt) => opt.value === modelFilter.isStreetLightAvailable) || null
                    }
                    onChange={(opt) => handleSelectFilterData("isStreetLightAvailable", opt?.value || "")}
                    placeholder="All"
                    styles={selectStyles}
                    classNamePrefix="react-select"
                  />
                </div>

                <div className="flex flex-col gap-1.5">
                  <label className="text-xs font-medium text-slate-600 dark:text-slate-400">Ownership Type</label>
                  <Select
                    options={[
                      { value: "", label: "All" },
                      { value: "Owned", label: "Owned" },
                      { value: "OnRent", label: "Rent" },
                      { value: "OnSubTenant", label: "Subtenant" },
                    ]}
                    value={
                      [
                        { value: "", label: "All" },
                        { value: "Owned", label: "Owned" },
                        { value: "OnRent", label: "Rent" },
                        { value: "OnSubTenant", label: "Subtenant" },
                      ].find((opt) => opt.value === modelFilter.isShopOwnorOnRentOrOnSubTenant) || null
                    }
                    onChange={(opt) => handleSelectFilterData("isShopOwnorOnRentOrOnSubTenant", opt?.value || "")}
                    placeholder="All"
                    styles={selectStyles}
                    classNamePrefix="react-select"
                  />
                </div>

                <div className="flex flex-col gap-1.5">
                  <label className="text-xs font-medium text-slate-600 dark:text-slate-400">Is Rent Expired</label>
                  <Select
                    options={[
                      { value: "", label: "All" },
                      { value: "1", label: "Expired" },
                      { value: "0", label: "Not Expired" },
                    ]}
                    value={
                      [
                        { value: "", label: "All" },
                        { value: "1", label: "Expired" },
                        { value: "0", label: "Not Expired" },
                      ].find((opt) => opt.value === modelFilter.isRentExpired) || null
                    }
                    onChange={(opt) => handleSelectFilterData("isRentExpired", opt?.value || "")}
                    placeholder="All"
                    // isDisabled={
                    //     modelFilter.ownershipType !== "all" &&
                    //     modelFilter.ownershipType !== "rent" &&
                    //     modelFilter.ownershipType !== "subtenant"
                    // }
                    styles={{
                      ...selectStyles,
                      control: (provided, state) => ({
                        ...selectStyles.control(provided, state),
                        opacity: state.isDisabled ? 0.6 : 1,
                        cursor: state.isDisabled ? "not-allowed" : "pointer",
                      }),
                    }}
                    classNamePrefix="react-select"
                  />
                </div>

                <div className="flex flex-col gap-1.5">
                  <label className="text-xs font-medium text-slate-600 dark:text-slate-400">Shop Type</label>
                  <Select
                    options={[{ value: "", label: "All Types" }, ...stallTypeOptions]}
                    value={[{ value: "", label: "All Types" }, ...stallTypeOptions].find((opt) => opt.value === modelFilter.shopType) || null}
                    onChange={(opt) => handleSelectFilterData("shopType", opt?.value || "")}
                    placeholder="All Types"
                    styles={selectStyles}
                    classNamePrefix="react-select"
                  />
                </div>

                {/* Start Date */}
                <div className="flex flex-col gap-1.5">
                  <label className="text-xs font-medium text-slate-600 dark:text-slate-400">Start Date</label>
                  <Flatpickr
                    options={{ dateFormat: "d-m-Y" }}
                    value={modelFilter?.startDate}
                    className="w-full px-3 py-2 border border-slate-300 dark:border-slate-600 rounded-lg bg-slate-50 dark:bg-slate-700 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all"
                    onChange={(e) => handleSelectFilterData("startDate", e?.[0])}
                    placeholder="DD-MM-YYYY"
                  />
                </div>

                {/* End Date */}
                <div className="flex flex-col gap-1.5">
                  <label className="text-xs font-medium text-slate-600 dark:text-slate-400">End Date</label>
                  <Flatpickr
                    options={{ dateFormat: "d-m-Y" }}
                    value={modelFilter?.endDate}
                    className="w-full px-3 py-2 border border-slate-300 dark:border-slate-600 rounded-lg bg-slate-50 dark:bg-slate-700 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all"
                    onChange={(e) => handleSelectFilterData("endDate", e?.[0])}
                    placeholder="DD-MM-YYYY"
                  />
                  {!validateStartAndEndDate(modelFilter?.startDate, modelFilter?.endDate) && (
                    <p className="text-xs text-red-600 dark:text-red-400 mt-1">End date cannot be before start date</p>
                  )}
                </div>
                <div className="flex flex-col flex-nowrap gap-1.5">
                  {/* <button
                    onClick={handleReset}
                    className="px-5 py-2.5 text-sm font-medium rounded-lg border border-slate-300 dark:border-slate-600 text-slate-700 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-700 transition-colors min-w-[100px]"
                >
                    Reset
                </button> */}
                  <div className="flex justify-start mt-5">
                    <button
                      onClick={handleFilterSearch}
                      disabled={!validateStartAndEndDate(modelFilter?.startDate, modelFilter?.endDate)}
                      className="px-4 py-2.5 mr-2 text-sm font-medium bg-blue-600 hover:bg-blue-700 text-white rounded-lg shadow-sm transition-all disabled:opacity-50 disabled:cursor-not-allowed min-w-[100px]  "
                    >
                      Filter
                    </button>

                    <button
                      onClick={handleExport}
                      disabled={isExporting}
                      className="px-4 py-2.5 text-sm font-medium bg-green-600 hover:bg-green-700 text-white rounded-lg shadow-sm transition-all disabled:opacity-50 disabled:cursor-not-allowed min-w-[100px] flex items-center justify-center gap-2"
                    >
                      {isExporting ? <span className="animate-spin h-4 w-4 border-2 border-white border-t-transparent rounded-full" /> : "Excel"}
                    </button>
                  </div>
                </div>
              </div>

              {/* Action Buttons */}
            </div>
          )}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {/* 1. Owned Shop */}
          <div
            // onClick={() => handleNavigate("openShop")}
            className="cursor-pointer flex flex-col gap-2 rounded-xl p-6 bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 shadow-sm relative overflow-hidden group hover:shadow-md transition-shadow"
          >
            <div className="absolute right-0 top-0 p-4 opacity-10 group-hover:opacity-20 transition-opacity">
              <span className="material-symbols-outlined text-green-600" style={{ fontSize: 64 }}>
                storefront
              </span>
            </div>
            <p className="text-[#4c739a] dark:text-gray-400 text-sm font-semibold uppercase tracking-wider">Owned Shop</p>
            <p className="text-[#0d141b] dark:text-white text-3xl font-bold leading-none">{countData?.[0]?.OwnedCount || "0"}</p>
          </div>

          {/* 2. Rent Shop */}
          {/* <div
            // onClick={() => handleNavigate("openShop")}
            className="cursor-pointer flex flex-col gap-2 rounded-xl p-6 bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 shadow-sm relative overflow-hidden group hover:shadow-md transition-shadow"
          >
            <div className="absolute right-0 top-0 p-4 opacity-10 group-hover:opacity-20 transition-opacity">
              <span className="material-symbols-outlined text-green-600" style={{ fontSize: 64 }}>
                storefront
              </span>
            </div>
            <p className="text-[#4c739a] dark:text-gray-400 text-sm font-semibold uppercase tracking-wider">Rent Shop</p>
            <p className="text-[#0d141b] dark:text-white text-3xl font-bold leading-none">{countData?.[0]?.RentCount || "0"}</p>
          </div> */}
          <div className="cursor-pointer rounded-xl p-4 bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 shadow-sm relative overflow-hidden group hover:shadow-md transition-shadow">
            {/* Background Icon */}
            <div className="absolute right-3 top-3 opacity-10 group-hover:opacity-20 transition-opacity">
              <span className="material-symbols-outlined text-green-600" style={{ fontSize: 52 }}>
                storefront
              </span>
            </div>

            {/* Title */}
            <p className="text-xs font-semibold uppercase tracking-wider text-[#4c739a] dark:text-gray-400">Rent Shop</p>

            {/* Main Count */}
            <p className="text-2xl font-bold text-[#0d141b] dark:text-white leading-none mt-1">{countData?.[0]?.RentCount || "0"}</p>

            {/* Bottom Compact Breakdown */}
            <div className="flex items-center justify-between mt-3 pt-2 border-t border-slate-200 dark:border-slate-700 text-xs font-medium">
              <div className="flex items-center gap-1">
                <span className="w-2 h-2 rounded-full bg-green-600"></span>
                <span className="text-gray-500 dark:text-gray-400">Yes</span>
                <span className="font-semibold text-green-600">{countData?.[0]?.YesRentCount || "0"}</span>
              </div>

              <div className="flex items-center gap-1">
                <span className="w-2 h-2 rounded-full bg-red-600"></span>
                <span className="text-gray-500 dark:text-gray-400">No</span>
                <span className="font-semibold text-red-600">{countData?.[0]?.NoRentCount || "0"}</span>
              </div>

              <div className="flex items-center gap-1">
                <span className="w-2 h-2 rounded-full bg-yellow-500"></span>
                <span className="text-gray-500 dark:text-gray-400">N/A</span>
                <span className="font-semibold text-yellow-500">{countData?.[0]?.NotApplicableRentCount || "0"}</span>
              </div>
            </div>
          </div>

          {/* 3. Subtenant Shop */}
          {/* <div
            // onClick={() => handleNavigate("openShop")}
            className="cursor-pointer flex flex-col gap-2 rounded-xl p-6 bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 shadow-sm relative overflow-hidden group hover:shadow-md transition-shadow"
          >
            <div className="absolute right-0 top-0 p-4 opacity-10 group-hover:opacity-20 transition-opacity">
              <span className="material-symbols-outlined text-green-600" style={{ fontSize: 64 }}>
                storefront
              </span>
            </div>
            <p className="text-[#4c739a] dark:text-gray-400 text-sm font-semibold uppercase tracking-wider">Subtenant Shop</p>
            <p className="text-[#0d141b] dark:text-white text-3xl font-bold leading-none">{countData?.[0]?.SubTenantCount || "0"}</p>
          </div> */}
          <div className="cursor-pointer rounded-xl p-4 bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 shadow-sm relative overflow-hidden group hover:shadow-md transition-shadow">
            {/* Background Icon */}
            <div className="absolute right-3 top-3 opacity-10 group-hover:opacity-20 transition-opacity">
              <span className="material-symbols-outlined text-green-600" style={{ fontSize: 52 }}>
                storefront
              </span>
            </div>

            {/* Title */}
            <p className="text-xs font-semibold uppercase tracking-wider text-[#4c739a] dark:text-gray-400">Subtenant Shop</p>

            {/* Main Count */}
            <p className="text-2xl font-bold text-[#0d141b] dark:text-white leading-none mt-1">{countData?.[0]?.SubTenantCount || "0"}</p>

            {/* Bottom Compact Breakdown */}
            <div className="flex items-center justify-between mt-3 pt-2 border-t border-slate-200 dark:border-slate-700 text-xs font-medium">
              {/* Yes */}
              <div className="flex items-center gap-1">
                <span className="w-2 h-2 rounded-full bg-green-600"></span>
                <span className="text-gray-500 dark:text-gray-400">Yes</span>
                <span className="font-semibold text-green-600">{countData?.[0]?.YesSubTenantCount || "0"}</span>
              </div>

              {/* No */}
              <div className="flex items-center gap-1">
                <span className="w-2 h-2 rounded-full bg-red-600"></span>
                <span className="text-gray-500 dark:text-gray-400">No</span>
                <span className="font-semibold text-red-600">{countData?.[0]?.NoSubTenantCount || "0"}</span>
              </div>

              {/* Not Applicable */}
              <div className="flex items-center gap-1">
                <span className="w-2 h-2 rounded-full bg-yellow-500"></span>
                <span className="text-gray-500 dark:text-gray-400">N/A</span>
                <span className="font-semibold text-yellow-500">{countData?.[0]?.NotApplicableSubTenantCount || "0"}</span>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-white dark:bg-slate-900 rounded-2xl shadow-lg border border-slate-200/80 dark:border-slate-700/50 overflow-hidden">
          <div className="m-2">
            <PageCountSelect rowsPerPage={rowsPerPage} handleRowsChange={handleRowsChange} />
          </div>
          <div className="overflow-x-auto">
            {isLoading || isFetching ? (
              <table className="min-w-full divide-y divide-slate-200 dark:divide-slate-800">
                <thead className="bg-slate-50 dark:bg-slate-800/50 sticky top-0 z-10">
                  <tr>
                    <th className="py-3.5 pl-4 pr-3 text-left text-xs font-semibold uppercase tracking-wide text-slate-500 dark:text-slate-400 sm:pl-6">Sr No</th>
                    <th className="px-3 py-3.5 text-left text-xs font-semibold uppercase tracking-wide text-slate-500 dark:text-slate-400">Status</th>
                    <th className="py-3.5 pl-4 pr-3 text-left text-xs font-semibold uppercase tracking-wide text-slate-500 dark:text-slate-400 sm:pl-6">
                      Shop Name / Type / Mobile no
                    </th>
                    {/* <th className="px-3 py-3.5 text-left text-xs font-semibold uppercase tracking-wide text-slate-500 dark:text-slate-400">
                                            Mobile Number
                                        </th> */}
                    <th className="px-3 py-3.5 text-left text-xs font-semibold uppercase tracking-wide text-slate-500 dark:text-slate-400">Area / Zone</th>
                    <th className="px-3 py-3.5 text-left text-xs font-semibold uppercase tracking-wide text-slate-500 dark:text-slate-400">Status</th>

                    <th className="px-3 py-3.5 text-left text-xs font-semibold uppercase tracking-wide text-slate-500 dark:text-slate-400">Working Time</th>
                    <th className="px-3 py-3.5 text-left text-xs font-semibold uppercase tracking-wide text-slate-500 dark:text-slate-400">Entry By Officer</th>
                    <th className="px-3 py-3.5 text-left text-xs font-semibold uppercase tracking-wide text-slate-500 dark:text-slate-400">Shop Details</th>
                    <th className="px-3 py-3.5 text-left text-xs font-semibold uppercase tracking-wide text-slate-500 dark:text-slate-400">Image</th>
                    <th className="px-3 py-3.5 text-left text-xs font-semibold uppercase tracking-wide text-slate-500 dark:text-slate-400">Actions</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-slate-100 dark:divide-slate-800/70">
                  {[...Array(8)].map((_, i) => (
                    <ShimmerRow key={i} />
                  ))}
                </tbody>
              </table>
            ) : currentItems.length === 0 ? (
              // Beautiful No Data Found UI
              <NoDataFound />
            ) : (
              <table className="min-w-full divide-y divide-slate-200 dark:divide-slate-700">
                <thead className="bg-slate-50 dark:bg-slate-800/50 sticky top-0 z-10">
                  <tr>
                    <th className="py-3.5 pl-4 pr-3 text-left text-xs font-semibold uppercase tracking-wide text-slate-500 dark:text-slate-400 sm:pl-6">Sr No</th>
                    <th className="px-3 py-3.5 text-left text-xs font-semibold uppercase tracking-wide text-slate-500 dark:text-slate-400">Status</th>
                    <th className="py-3.5 pl-4 pr-3 text-left text-xs font-semibold uppercase tracking-wide text-slate-500 dark:text-slate-400 sm:pl-6">
                      Shop Name / Type / Mobile no
                    </th>
                    {/* <th className="px-3 py-3.5 text-left text-xs font-semibold uppercase tracking-wide text-slate-500 dark:text-slate-400">
                                            Mobile Number
                                        </th> */}
                    <th className="px-3 py-3.5 text-left text-xs font-semibold uppercase tracking-wide text-slate-500 dark:text-slate-400">Area / Zone</th>
                    <th className="px-3 py-3.5 text-left text-xs font-semibold uppercase tracking-wide text-slate-500 dark:text-slate-400">Status</th>

                    <th className="px-3 py-3.5 text-left text-xs font-semibold uppercase tracking-wide text-slate-500 dark:text-slate-400">Working Time</th>
                    <th className="px-3 py-3.5 text-left text-xs font-semibold uppercase tracking-wide text-slate-500 dark:text-slate-400">Entry By Officer</th>
                    <th className="px-3 py-3.5 text-left text-xs font-semibold uppercase tracking-wide text-slate-500 dark:text-slate-400">Shop Details</th>
                    <th className="px-3 py-3.5 text-left text-xs font-semibold uppercase tracking-wide text-slate-500 dark:text-slate-400">QR Code</th>
                    <th className="px-3 py-3.5 text-left text-xs font-semibold uppercase tracking-wide text-slate-500 dark:text-slate-400">Image</th>
                    <th className="px-3 py-3.5 text-left text-xs font-semibold uppercase tracking-wide text-slate-500 dark:text-slate-400">Actions</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-slate-200  dark:divide-slate-700">
                  {pages[currentPage]?.data?.length
                    ? pages[currentPage]?.data.map((shop, idx) => {
                        const absoluteIndex = currentPage * rowsPerPage + idx + 1;
                        const isActive = shop.IsActive === "true" || shop.IsActive === true;
                        const imageUrl = shop.ShopImage ? `${NIGHT_EYE_IMG_URL}/SmartCollection/ShopImage/${shop.ShopImage}` : null;
                        return (
                          <>
                            <tr key={idx} className="  hover:bg-slate-50 dark:hover:bg-slate-800/50 transition-colors">
                              <td className=" py-4 pl-4 pr-3 text-sm font-medium text-slate-900 dark:text-white sm:pl-6">{absoluteIndex}</td>
                              <td className="  py-4 text-sm">
                                <label className="relative inline-flex items-center cursor-pointer">
                                  <input
                                    type="checkbox"
                                    checked={openTableDetails[shop?.ShopDetailID]}
                                    onChange={() => handleShowHideTableDetails(shop?.ShopDetailID, !openTableDetails[shop?.ShopDetailID])}
                                    className="sr-only peer"
                                  />
                                  <div
                                    className={`
                                  w-9 h-5 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 
                                  peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 
                                  rounded-full peer dark:bg-gray-700 
                                  peer-checked:after:translate-x-full 
                                  peer-checked:after:border-white 
                                  after:content-[''] after:absolute after:top-[2px] after:left-[2px] 
                                  after:bg-white after:border-gray-300 after:border after:rounded-full 
                                  after:h-4 after:w-4 after:transition-all 
                                  dark:border-gray-600 
                                  peer-checked:bg-green-600
                                `}
                                  ></div>
                                  {/* <span className="ml-3 text-sm font-medium text-gray-900 dark:text-gray-300">
                                {isActive ? "Active" : "Inactive"}
                              </span> */}
                                </label>
                              </td>
                              <td className=" py-4 pl-4 pr-3 text-sm font-medium text-slate-900 dark:text-white sm:pl-6">
                                <div className="flex flex-col">
                                  <p className="text-[#0d141b] dark:text-white font-bold text-base">{shop.ShopName || ""}</p>
                                  <p className="text-[#4c739a] dark:text-gray-400 text-xs">{shop.Type}</p>
                                  {/* <p className="text-[#4c739a] dark:text-gray-400 text-xs">{shop.ShopMobileNo1}</p> */}
                                  <p className="text-[#4c739a] dark:text-gray-400 text-xs">{shop?.ShopUserDetail?.[0]?.ShopUserMobileNo}</p>
                                </div>
                              </td>
                              {/* <td className=" px-3 py-4 text-sm text-slate-500 dark:text-slate-400">
                                                        <p className="text-sm text-[#0d141b] dark:text-gray-200">
                                                            {shop.ShopMobileNo1 || '—'}
                                                        </p>

                                                    </td> */}
                              <td className=" px-3 py-4 text-sm text-slate-500 dark:text-slate-400">
                                <p className="text-sm text-[#0d141b] dark:text-gray-200">{shop.AreaName || "—"}</p>
                                <p className="text-xs text-[#4c739a] dark:text-gray-400">{shop.ZoneName || "—"}</p>
                              </td>
                              <td className=" px-3 py-4 text-sm font-medium">
                                <div
                                  className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-bold ${
                                    shop.ShopVerifiedStatus === "true"
                                      ? "bg-emerald-50 dark:bg-emerald-900/30 border border-emerald-100 dark:border-emerald-800 text-emerald-700 dark:text-emerald-400"
                                      : "bg-amber-50 dark:bg-amber-900/30 border border-amber-100 dark:border-amber-800 text-amber-700 dark:text-amber-400"
                                  }`}
                                >
                                  <span className={`size-1.5 rounded-full ${shop.ShopVerifiedStatus === "true" ? "bg-emerald-600" : "bg-amber-500"}`} />
                                  {shop.ShopVerifiedStatus === "true" ? "Verified" : "Pending"}
                                </div>
                              </td>

                              <td className=" px-3 py-4 text-sm">
                                <p className="text-sm text-[#0d141b] dark:text-gray-200">
                                  {shop.ShopOpenTime} – {shop.ShopCloseTime}
                                </p>
                              </td>
                              <td className=" px-3 py-4 text-sm">
                                <p className="text-sm text-[#0d141b] dark:text-gray-200">{shop.CreatedByUserName}</p>
                              </td>
                              <td className="whitespace-wrap px-3 py-4 text-sm text-center">
                                <span onClick={() => handleViewShopDetails(shop)} className="material-symbols-outlined cursor-pointer text-xl">
                                  visibility{" "}
                                </span>
                                <button
                                  onClick={() => directionOnMap(shop)}
                                  className="flex items-center gap-1.5 w-full justify-center px-2 py-1.5 me-2 mb-2 text-xs font-bold text-white bg-primary bg-primary-600 rounded-lg hover:bg-primary-700 shadow-sm shadow-primary-500/30 transition-colors"
                                >
                                  <span className="material-symbols-outlined text-[16px]">map</span>
                                  On Map
                                </button>

                                {/* Modal */}
                                {openMapModel && (
                                  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/10 directiondivMap">
                                    <div className="bg-white rounded-lg w-[100%] max-w-5xl p-4 relative">
                                      <button onClick={() => setOpenMapModel(false)} className="absolute top-2 right-2 text-gray-600 mapzindex">
                                        ✕
                                      </button>

                                      <DirectionMap directionData={directionData} />
                                    </div>
                                  </div>
                                )}
                              </td>
                              <td className="px-3 py-4 text-sm text-center">
                                {/* <div className="flex justify-center"> */}
                                <ShopQR shop={shop} />
                                {/* </div> */}
                              </td>
                              <td>
                                <div
                                  className="size-12 rounded-lg bg-cover bg-center shrink-0 border border-gray-200 dark:border-gray-600"
                                  // style={{
                                  //   backgroundImage: shop.ShopImage ? `url(/uploads/shop/${shop.ShopImage})` : 'none',
                                  // }}
                                >
                                  {!shop.ShopImage ? (
                                    <div className="h-full flex items-center justify-center text-gray-400">
                                      <span className="material-symbols-outlined">store</span>
                                    </div>
                                  ) : (
                                    <div className="h-full flex items-center justify-center text-gray-400">
                                      <div
                                        className="size-10 rounded-lg bg-slate-100 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 cursor-pointer overflow-hidden group relative"
                                        onClick={() => openModal(imageUrl)}
                                      >
                                        <div className="absolute inset-0 bg-black/0 group-hover:bg-black/40 transition-colors flex items-center justify-center">
                                          <span className="material-symbols-outlined text-white opacity-0 group-hover:opacity-100 text-xl">visibility</span>
                                        </div>
                                        <img
                                          src={imageUrl}
                                          alt="Shop close proof"
                                          className="w-full h-full object-cover"
                                          onError={(e) => {
                                            e.target.src = "/fallback-proof-placeholder.jpg"; // optional fallback
                                          }}
                                        />
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </td>
                              <td className="flex">
                                <div className="mt-3 px-2">
                                  <button
                                    onClick={() => handleAddMoreShop(shop)}
                                    className="flex items-center w-full justify-center gap-1.5 px-2 py-1.5 me-2 mb-2 text-xs font-bold text-white bg-green-600 rounded-lg hover:bg-green-700 shadow-sm shadow-green-500/30 transition-colors"
                                  >
                                    <span className="material-symbols-outlined text-[16px]">cloud_upload</span>
                                    Add
                                  </button>
                                  <button
                                    onClick={() => handleEditShop(shop)}
                                    className="flex items-center gap-1.5 w-full justify-center px-2 py-1.5 me-2 mb-2 text-xs font-bold text-white bg-primary bg-primary-600 rounded-lg hover:bg-primary-700 shadow-sm shadow-primary-500/30 transition-colors"
                                  >
                                    <span className="material-symbols-outlined text-[16px]">cloud_upload</span>
                                    Edit
                                  </button>
                                  <button
                                    onClick={() => handleVendorReport(shop)}
                                    className="flex items-center gap-1.5 w-full justify-center px-2 py-1.5 me-2 mb-2 text-xs font-bold text-white bg-red-600 rounded-lg hover:bg-red-700 shadow-sm shadow-red-500/30 transition-colors"
                                  >
                                    <span className="material-symbols-outlined text-[16px]">cloud_upload</span>
                                    Report
                                  </button>
                                </div>
                              </td>
                            </tr>
                            {/* <AnimatePresence>
                                                    {openTableDetails[shop?.ShopDetailID] && (
                                                        <>
                                                            <motion.tr
                                                                initial={{ maxHeight: 0, opacity: 0 }}
                                                                animate={{ maxHeight: 500, opacity: 1 }}
                                                                exit={{ maxHeight: 0, opacity: 0 }}
                                                                transition={{ duration: 0.4, ease: "easeInOut" }}
                                                                className="overflow-hidden bg-gray-50"
                                                                style={{ background: "#f7f7f7" }}
                                                            >
                                                                <td colSpan={9} className="whitespace-wrap px-3 py-4 text-sm">
                                                                    <table className="min-w-full divide-y divide-slate-200 dark:divide-slate-700">
                                                                        <thead className="bg-slate-50 dark:bg-slate-800/50 sticky top-0 z-10">
                                                                            <tr>
                                                                                <th className="py-3.5 pl-4 pr-3 text-left text-xs font-semibold uppercase tracking-wide text-slate-500 dark:text-slate-400 sm:pl-6">
                                                                                    Address
                                                                                </th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody className="divide-y divide-slate-200 dark:divide-slate-700">

                                                                            <tr className="hover:bg-slate-50 dark:hover:bg-slate-800/50 transition-colors">
                                                                                <td className="whitespace-wrap py-4 pl-4 pr-3 text-sm font-medium text-slate-900 dark:text-white sm:pl-6">
                                                                                    {shop.Address}
                                                                                </td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </td>
                                                            </motion.tr>
                                                        </>
                                                    )}
                                                </AnimatePresence> */}
                          </>
                        );
                      })
                    : ""}
                </tbody>
              </table>
            )}
          </div>
        </div>
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 px-4 sm:px-6 py-4">
          <PageEntries start={start} end={end} totalCount={totalCount} />

          <PaginationButtons currentPage={currentPage} setCurrentPage={setCurrentPage} goToPage={goToPage} pages={pages} hasNextPage={hasNextPage} fetchNextPage={fetchNextPage} />
        </div>
        {selectedImage && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm p-4" onClick={closeModal}>
            <div className="relative max-w-5xl max-h-[90vh] w-full h-full rounded-xl overflow-hidden shadow-2xl" onClick={(e) => e.stopPropagation()}>
              {/* Close button */}
              <button
                className="absolute top-4 right-4 z-10 bg-black/50 hover:bg-black/70 text-white rounded-full p-2 transition-colors"
                onClick={closeModal}
                aria-label="Close modal"
              >
                <span className="material-symbols-outlined">close</span>
              </button>

              {/* Image */}
              <img
                src={selectedImage}
                alt="Full size shop close proof"
                className="w-full h-full object-contain bg-slate-900"
                onError={(e) => {
                  e.target.src = "/fallback-large-placeholder.jpg";
                }}
              />
            </div>
          </div>
        )}
        {isReportModalOpen && <ShopReportModal isOpen={isReportModalOpen} refetch={refetch} onClose={onReportModelclose} selectedShop={selectedShop} />}
        {openShopDetails && <ShopDetailModal shop={shopProfileDetailView} isOpen={openShopDetails} onClose={handleCloseShopDetails} />}
      </div>
    </main>
  );
};

export default DepartmentVendorLIst;
